import { navigatorArtworkSize } from "@/helpers/pageHelpers/Common/interface";
import { defaultRadioArtwork } from "@/store/PlayerStore";

export function updateNavigator({
  title,
  subTitle,
  artwork,
  size = navigatorArtworkSize.Small,
}: {
  title: string;
  subTitle: string;
  artwork: string;
  size?: navigatorArtworkSize;
}) {
  const isSmallArtwork = size === navigatorArtworkSize.Small;

  if ("mediaSession" in navigator) {
    navigator.mediaSession.metadata = new MediaMetadata({
      title,
      artist: subTitle,
      artwork: [
        {
          src: artwork || defaultRadioArtwork,
          sizes: isSmallArtwork ? "100x100" : "600x600",
        },
      ],
    });
  }
}
